import { render } from "./TreeMergeFile.vue?vue&type=template&id=7924b8c7&scoped=true"
import script from "./TreeMergeFile.js?vue&type=script&lang=js"
export * from "./TreeMergeFile.js?vue&type=script&lang=js"

import "./TreeMergeFile.vue?vue&type=style&index=0&id=7924b8c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7924b8c7"]])

export default __exports__